import { render, staticRenderFns } from "./data-item.vue?vue&type=template&id=0f9af8fe&scoped=true"
import script from "./data-item.vue?vue&type=script&lang=js"
export * from "./data-item.vue?vue&type=script&lang=js"
import style0 from "./data-item.vue?vue&type=style&index=0&id=0f9af8fe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9af8fe",
  null
  
)

export default component.exports